import { Reveal } from "../components/Reveal";

export default function News() {
  return (
    <div data-testid="news-page" className="pt-16">
      <div className="px-6 md:px-10 lg:px-20 pt-16 pb-40 min-h-[70vh]">
        <Reveal>
          <p className="util-link text-[11px] caption mb-4">Journal</p>
          <h1 className="font-display text-5xl sm:text-7xl uppercase leading-[0.9]">News</h1>
          <p className="caption text-sm mt-8 max-w-md">Stories, guides and dispatches from the rinova studio — coming soon.</p>
        </Reveal>
      </div>
    </div>
  );
}
